import { SvgIcon } from "@mui/material"
import { ReactComponent as gb } from "assets/svg/flags/gb.svg"
import { ReactComponent as th } from "assets/svg/flags/th.svg"

const flagSvgs = {
  th,
  gb,
}
export const CountryFlag = ({ flagCode, ...props }) => (
  <SvgIcon component={flagSvgs[flagCode]} inheritViewBox {...props} />
)
